/**
 * Created by Tomasz Gabrysiak @ Infermedica on 08/02/2017.
 */

import html from '../../templates/helpers';

const template = (context) => {
  return new Promise((resolve) => {
    resolve(html`
      <h5 class="card-title">আপনার কেমন লাগছে তা বলুন।</h5>
      <div class="card-text">
        <form>
          <div class="form-group">
            <label for="input-feel">আমরা প্রাকৃতিক ভাষা প্রসেসিং অ্যালগরিদম ব্যবহার করে আপনার লক্ষণগুলি সনাক্ত করার চেষ্টা করব।</label>
            <textarea placeholder="e.g. I got headache" class="form-control" id="input-feel" rows="4"></textarea>
          </div>
        </form>
        <p>চিহ্নিত পর্যবেক্ষণগুলি:</p>
        <ul class="list-unstyled" id="observations">
        </ul>
      </div>
    `);
  });
};

export default template;



// WEBPACK FOOTER //
// ./src/components/nlp/template.js